var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    "mirror-in-rtl": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M17.707 8.86l-5.756 5.662c-.392.387-2.485 1.8-2.882 1.41s1.052-2.437 1.445-2.824l5.756-5.662a1.023 1.023 0 0 1 1.43.007.983.983 0 0 1 .007 1.407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M12.6 0H1.4A1.417 1.417 0 0 0 0 1.43v15.14A1.417 1.417 0 0 0 1.4 18h11.2a1.417 1.417 0 0 0 1.4-1.43v-2.72l-1.39 1.39c-.02.02-1.93 1.76-3.35 1.76a1.22 1.22 0 0 1-.9-.35c-.8-.81-.06-2.08.26-2.63a9.97 9.97 0 0 1 1.16-1.61L14 8.19V1.43A1.417 1.417 0 0 0 12.6 0zM3.03 2H8a1 1 0 0 1 0 2H3.03a1 1 0 0 1 0-2zM7 12.01L3 12a1 1 0 1 1 0-1.99h4a1 1 0 0 1 0 2zM11 8H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftSvgrepoCom);
export default __webpack_public_path__ + "static/media/draft-svgrepo-com.008f12a73dab03d397c5c9362ecbc335.svg";
export { ForwardRef as ReactComponent };